import "@sitebuilder/assets/scss/cms/navigation.scss";
import utils from "./razorUtils.js";

const initNavigation = (nav, hamburgerMenu) => {
  nav.addEventListener("mouseleave", (e) => (_timeoutHideMenu = setTimeout(() => currentMenu && focusMenu(null), 300)));
alert('ok');
  let isMobileOpened = false;

  const navList = nav.querySelector(".navigation-list");

  if (hamburgerMenu) {
    hamburgerMenu.addEventListener("click", (e) => {
      hamburgerMenu.classList.toggle("close");
      navList.classList.toggle("visible");
      isMobileOpened = hamburgerMenu.classList.contains("close");
      hamburgerMenu.setAttribute("aria-expanded", isMobileOpened);
    });
  }

  const menus = Array.from(nav.querySelectorAll(".menu"));

  let currentMenu = null;

  const getParentAndSelfMenus = (menu) => {
    const arr = [];
    if (!menu) return arr;
    arr.push(menu);

    const addRecursiveParents = (menu, arr) => {
      const parentId = menu.id.substring(0, menu.id.lastIndexOf("."));
      const parent = document.getElementById(parentId);
      if (parent) {
        arr.push(parent);
        addRecursiveParents(parent, arr);
      }
    };
    addRecursiveParents(menu, arr);
    return arr.reverse();
  };

  const activeMenu = (menu) => {
    if (isMenuDropdown(menu)) {
      getMenuDropdown(menu).classList.add("active");
      menu.setAttribute("aria-expanded", "true");
      menu.nextElementSibling.setAttribute("aria-hidden", "false");
    } else {
      menu.classList.add("active");
    }
  };

  const desactiveMenu = (menu) => {
    if (isMenuDropdown(menu)) {
      getMenuDropdown(menu).classList.remove("active");
      menu.setAttribute("aria-expanded", "false");
      menu.nextElementSibling.setAttribute("aria-hidden", "true");
    } else {
      menu.classList.remove("active");
    }
    menu.blur();
  };

  let _timeoutHideMenu = null;
  const clearHideMenuTimeout = () => {
    if (_timeoutHideMenu) {
      clearTimeout(_timeoutHideMenu);
      _timeoutHideMenu = null;
    }
  };

  const focusMenu = (node) => {
    if (node) {
      clearHideMenuTimeout();
    }

    if (node == currentMenu) return;
    const actuals = getParentAndSelfMenus(currentMenu);
    const news = getParentAndSelfMenus(node);

    // Unselect of menu from actuals not present in news
    actuals.forEach((menu, index) => {
      if (index >= news.length || news[index] != actuals[index]) {
        desactiveMenu(actuals[index]);
      }
    });

    // Select menu from news not present in actuals
    news.forEach((menu, index) => {
      if (index >= actuals.length || news[index] != actuals[index]) {
        activeMenu(news[index]);
      }
    });

    currentMenu = node;
    if (node && document.activeElement !== node) {
      node.focus();
    }
  };

  const selectMenuByOffset = (offset) => {
    setTimeout(clearHideMenuTimeout, 10);

    if (!currentMenu) return;
    const ol = currentMenu.closest("ol");

    const menus = Array.from(ol.querySelectorAll(":not(ol) > .menu"));
    let index = menus.indexOf(currentMenu);
    // console.log('move to INDEX', index + offset)

    if (index < 0) return;

    index += offset;
    if (index < 0) return;
    if (index >= menus.length) return;

    menus[index].focus();
  };

  const getMenuDropdown = (menu) => menu.parentNode;
  const isMenuDropdown = (menu) => getMenuDropdown(menu).classList.contains("menu-dropdown");

  menus.forEach((menu) => {
    menu.addEventListener("mouseover", () => !(utils.isMobile() && isMobileOpened) && focusMenu(menu));
    menu.addEventListener("focus", () => !(utils.isMobile() && isMobileOpened) && focusMenu(menu));
    menu.addEventListener("blur", (e) => {
      if (!(utils.isMobile() && isMobileOpened) && e.relatedTarget && !nav.contains(e.relatedTarget)) {
        focusMenu(null);
      }
    });
    menu.addEventListener("click", (e) => {
      if (utils.isMobile() && isMenuDropdown(menu)) {
        focusMenu(menu);
        e.preventDefault();
      }
    });

    if (isMenuDropdown(menu)) {
      getMenuDropdown(menu)
        .querySelector(".menu-dropdown-content-title")
        .addEventListener("click", (e) => {
          const last2Menus = getParentAndSelfMenus(menu).slice(-2);
          focusMenu(last2Menus.length == 2 ? last2Menus.pop() : null);
        });
    }

    menu.addEventListener("keydown", (e) => {
      if (e.keyCode === 37) {
        // left
        selectMenuByOffset(-1);
        e.preventDefault();
      } else if (e.keyCode === 39) {
        // right
        selectMenuByOffset(1);
        e.preventDefault();
      }
    });
  });
};

export default initNavigation;
